<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GvNWzO/tc-custom/9781449485542.jpg?1731182066451" alt="This image is the cover for the book If You Give a Man a Cookie"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">If You Give a Man a Cookie
      </h1>
      <p class="bookDescription body article font2">
        <p>If you give a man a cookie...he's going to want milk to go with it...God forbid he should get it himself.<br/><br/><i>If You Give a Man a Cookie</i> is a woman’s commentary about her helpless man and the chain of events that leads him on a journey from the bed to the bathroom to the couch and back to bed at nightfall.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Laura Joffe Numeroff, Brian Ajhar
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7d6fc0db